import React from 'react';
import { Container, Row, Col, Card, Alert, Badge, Button } from 'react-bootstrap';
import { BarChart3, Link2, Rocket, Target, Trophy } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Icon from '../components/Icon.jsx';

const DemoScreen = () => {
  const navigate = useNavigate();

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col lg={10}>
          <div className="text-center mb-5">
            <h1 className="text-primary mb-3">League Runner Demo</h1>
            <p className="lead text-secondary">
              Explore the enhanced athlete profile features with mock data
            </p>
          </div>

          <Row className="mb-4">
            <Col md={6}>
              <Card className="modern-card h-100">
                <Card.Body className="text-center">
                  <div className="mb-3 d-flex justify-content-center"><Icon icon={BarChart3} size={28} /></div>
                  <h4>Enhanced Athlete Profile</h4>
                  <p className="text-secondary mb-3">
                    View comprehensive athlete statistics, performance trends, and achievements
                  </p>
                  <Button variant="primary" onClick={() => navigate('/dashboard')} className="mb-2">
                    View My Dashboard
                  </Button>
                  <div>
                    <Badge bg="success" className="me-2">New</Badge>
                    <Badge bg="info">Demo Data</Badge>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="modern-card h-100">
                <Card.Body className="text-center">
                  <div className="mb-3 d-flex justify-content-center"><Icon icon={Link2} size={28} /></div>
                  <h4>Strava Integration</h4>
                  <p className="text-secondary mb-3">
                    Connect your Strava account to automatically import running activities
                  </p>
                  <Button variant="outline-primary" onClick={() => navigate('/strava')} className="mb-2">
                    View Strava Screen
                  </Button>
                  <div>
                    <Badge bg="warning" className="me-2">Enhanced</Badge>
                    <Badge bg="secondary">Integration</Badge>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Alert variant="info">
            <Alert.Heading><Icon icon={Rocket} size={16} className="me-1" />Feature Highlights</Alert.Heading>
            <Row>
              <Col md={6}>
                <h6><Icon icon={BarChart3} size={14} className="me-1" />Performance Analytics</h6>
                <ul className="small mb-3">
                  <li>Weekly mileage trends</li>
                  <li>Monthly point accumulation</li>
                  <li>Performance improvement tracking</li>
                  <li>League ranking system</li>
                </ul>
              </Col>
              <Col md={6}>
                <h6><Icon icon={Trophy} size={14} className="me-1" />Achievements System</h6>
                <ul className="small mb-3">
                  <li>Distance milestones</li>
                  <li>Consistency rewards</li>
                  <li>Progress tracking</li>
                  <li>Unlockable badges</li>
                </ul>
              </Col>
            </Row>
            <hr />
            <div className="d-flex justify-content-between align-items-center mb-0">
              <div>
                <strong>Ready to explore?</strong> The athlete profile now shows comprehensive statistics,
                activity history, and achievement progress.
              </div>
              <Button variant="primary" onClick={() => navigate('/dashboard')}>
                Get Started
              </Button>
            </div>
          </Alert>

          <Row className="mt-4">
            <Col md={4}>
              <Card className="modern-card text-center">
                <Card.Body>
                  <h6 className="text-primary"><Icon icon={BarChart3} size={14} className="me-1" />Statistics</h6>
                  <p className="small text-secondary mb-0">
                    Track distance, pace, time, and points earned from your activities
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="modern-card text-center">
                <Card.Body>
                  <h6 className="text-primary"><Icon icon={Target} size={14} className="me-1" />Goals</h6>
                  <p className="small text-secondary mb-0">
                    Set and achieve running milestones with the achievement system
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="modern-card text-center">
                <Card.Body>
                  <h6 className="text-primary"><Icon icon={Link2} size={14} className="me-1" />Activities</h6>
                  <p className="small text-secondary mb-0">
                    Import activities from Strava or view demo data to see features
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default DemoScreen;
